export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14993.cc32b696.jpg";